// OurStory.js
import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
};

const OurStory = () => {
  const values = [
    {
      title: "Done Right the First Time",
      desc: "We believe quality should never be compromised. Every project is completed with precision and care. Long-term performance is always our priority."
    },
    {
      title: "Integrity Over Speed",
      desc: "Rushing leads to costly mistakes. We focus on doing the work correctly the first time. Excellence always matters more than speed."
    },
    {
      title: "Radical Transparency",
      desc: "We communicate clearly from start to finish. Timelines and expectations are always realistic. Clients are never left guessing."
    },
    {
      title: "Honesty in Every Detail",
      desc: "We believe trust is built through honesty. There are no hidden costs or surprises. Every detail is shared openly and clearly."
    },
    {
      title: "Respect for People & Craft",
      desc: "We value our clients, our team, and our craft. Professionalism guides every interaction. Strong relationships are built on mutual respect."
    },
    {
      title: "Sustainability & Innovation",
      desc: "We embrace sustainable practices and innovative solutions to create homes and buildings that stand the test of time."
    }
  ];

  return (
    <section className="bg-[#f8f9fa] py-12 px-6">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <motion.div
          className="max-w-3xl mx-auto text-center mb-12"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
        >
          <motion.p
            variants={fadeUp}
            className="text-[#6c757d] uppercase tracking-wider text-xs md:text-sm font-semibold"
          >
            Our Story & Values
          </motion.p>

          <motion.h2
            variants={fadeUp}
            className="mt-2 text-3xl md:text-4xl font-bold text-[#212529]"
          >
            Built on Principles That Last
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="mt-3 text-[#495057] text-sm leading-relaxed"
          >
            Our approach to construction is grounded in values that guide every
            decision, every project, and every relationship we build.
          </motion.p>
        </motion.div>

        {/* Centered Cards */}
        <motion.div
          className="flex flex-wrap justify-center gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
        >
          {values.map((item, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              className="group relative bg-white rounded-xl p-5 border border-[#dee2e6] w-full sm:w-[320px]
                         transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_25px_rgba(73,80,87,0.2)]"
            >
              {/* Number + Title on same line */}
              <div className="flex items-center gap-3 mb-2">
                <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#495057] text-[#f8f9fa] flex items-center justify-center font-semibold text-xs relative -top-1">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <h3 className="text-base font-semibold text-[#212529] group-hover:text-[#212529] transition-colors duration-300">
                  {item.title}
                </h3>
              </div>

              {/* Paragraph below */}
              <p className="mt-2 text-sm text-[#6c757d] leading-relaxed group-hover:text-[#495057] transition-colors duration-300">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default OurStory;